import Component from "../../lib/component";

export const MoreFetcherButtonConfig = {
    componentTypeKey: "MoreFetcherButton",
    baseHtmlClass: "more_fetcher__button",
};

export class MoreFetcherButton extends Component {
    static createElement(options={}) {
        // Create the component's element…
        const element = document.createElement(options.nodeName || "div");
        element.classList.add(`${MoreFetcherButton.config.baseHtmlClass}`);
        const classNames = options.classNames.split(" ") || [];
        classNames.forEach(className => element.classList.add(className));

        // Add a liner div to the component's element…
        const liner = document.createElement("div");
        liner.classList.add('more_fetcher__button__liner');
        liner.style = "box-sizing: border-box; display: flex; justify-content: center; align-items: center; padding: 1em; margin: 0; width: 100%; height: 100%;";
        element.appendChild(liner);

        // Add the button into the liner element…
        const button = document.createElement("button");
        button.classList.add('btn');
        button.textContent = "Load More"; // Default text is replaced when rendering
        liner.appendChild(button);

        return element;
    }

    static get config() {
        return MoreFetcherButtonConfig;
    }

    constructor(id_or_element, moreFetcher) {
        super({ element: id_or_element, config: MoreFetcherButton.config });
        this.moreFetcher = moreFetcher;
        this.buttonElement = this.element.querySelector("button");

        this.buttonElement.addEventListener("click", this.handleClick.bind(this));

        this.render();
    }

    handleClick(event) {
        event.preventDefault();
        this.moreFetcher.fetchMore();
        this.moreFetcher.render();
    }

    render() {
        if (this.moreFetcher?.isLoading) {
            this.buttonElement.innerHTML = "Loading…";
            this.buttonElement.setAttribute("disabled", "disabled");
        } else {
            this.buttonElement.innerHTML = "Load More";
            this.buttonElement.removeAttribute("disabled");
        }

        if (this.moreFetcher?.getItemsRemainingCount() <= 0) {
            this.element.style.display = "none";
        } else {
            this.element.style.removeProperty("display");
        }

        // button should move itself to the end of its parent in case more items have been added to the container.
        this.element.parentElement.appendChild(this.element);
    }

}
